import { keepOnlyNumbers } from "@shared/utils/tools.ts";

export function useRootCssVar() {
  const globalTransitionDuration = Number(
    keepOnlyNumbers(
      getComputedStyle(document.documentElement).getPropertyValue(
        "--global-transition-duration",
      ),
    ) || 0,
  );

  const menuTransitionDuration = Number(
    keepOnlyNumbers(
      getComputedStyle(document.documentElement).getPropertyValue(
        "--menu-transition-duration",
      ),
    ) || 0,
  );
  const menuTransitionDurationMs = getComputedStyle(
    document.documentElement,
  ).getPropertyValue("--menu-transition-duration");

  const menuWidth = getComputedStyle(document.documentElement).getPropertyValue(
    "--menu-width",
  );

  const closedMenuWidth = getComputedStyle(
    document.documentElement,
  ).getPropertyValue("--menu-closed-width");

  const topBarGlobalNotificationHeightWithUnit = getComputedStyle(
    document.documentElement,
  ).getPropertyValue("--topBar-globalNotification-height");

  const topBarHeight = getComputedStyle(
    document.documentElement,
  ).getPropertyValue("--topBar-height");

  const pricingPageStickyHeaderHeight = cssVarToNumber(
    "--pricing-stickyHeader-height",
  );

  const breakpointsMobileInt = cssVarToNumber("--maxBreakpoints-mobile");
  const breakpointsTabletInt = cssVarToNumber("--maxBreakpoints-tablet");
  const breakpointsLaptopInt = cssVarToNumber("--maxBreakpoints-laptop");
  const breakpointsDesktopInt = cssVarToNumber("--maxBreakpoints-desktop");

  const pricingPageFooterHeight = cssVarToNumber("--pricing-footer-height");

  return {
    globalTransitionDuration,
    menuTransitionDuration,
    menuTransitionDurationMs,
    menuWidth,
    closedMenuWidth,
    topBarGlobalNotificationHeightWithUnit,
    topBarHeight,
    pricingPageStickyHeaderHeight,
    pricingPageFooterHeight,
    breakpointsMobileInt,
    breakpointsTabletInt,
    breakpointsLaptopInt,
    breakpointsDesktopInt,
  };
}

const cssVarToNumber = (cssVar: string) =>
  Number(
    keepOnlyNumbers(
      getComputedStyle(document.documentElement).getPropertyValue(cssVar),
    ) || 0,
  );
